import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const COURT_TYPE_BASE_PATH = '/CourtType';

export const courtTypeEndpoints = {
  list: () => buildEndpoint(COURT_TYPE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${COURT_TYPE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${COURT_TYPE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(COURT_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${COURT_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${COURT_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${COURT_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default courtTypeEndpoints;
